import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/exploration-logo.png'


const _hoisted_1 = { class: "header-root" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  alt: "exploration logo",
  src: _imports_0
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "header-title" }, "seismic viewer", -1)
const _hoisted_4 = { class: "header-spinner" }
const _hoisted_5 = { class: "profile-section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BusySpinner = _resolveComponent("BusySpinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_BusySpinner)
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", null, "Welcome, " + _toDisplayString(_ctx.profileName), 1)
    ], 512), [
      [_vShow, _ctx.isSignedIn]
    ])
  ]))
}